export const isChinese = (str: string) => {
  // 使用Unicode编码范围判断是否是中文字符
  // const regex = /[\u4e00-\u9fa5\uff00-\uffef0-9]+/g;
  // console.log(regex.test(str), '中文检测')
  const regex =  /^[\u4e00-\u9fa5a-zA-Z0-9\s.,，。！？；：‘’“”（）【】《》{}、·~@#$%^&*+\-=_|<>/\\]+|<break time="\d+(\.\d+)?s"\/>$/ // 这个正则表达式匹配基本汉字范围
  return regex.test(str.replace(/\s+/g, ""));
}
export const isEnglish = (str: string) => {
  const regex = /[a-zA-Z]/
  console.log(regex.test(str), '英语检测')
  return regex.test(str);
}
// 判断韩文
export const isKorean = (str: string) => {
  // Regular expression to match Korean characters
  const koreanCharRegex = /[가-힣]/;
  console.log(koreanCharRegex.test(str), '测试');
  
  return koreanCharRegex.test(str);
}
// 判断日文
export const isJapanese = (str: string) => {
  // const regExp = /[\u3040-\u30ff\u31f0-\u31ff\u4e00-\u9fa5\u3000-\u303f0-9!-/:-@[-`{-~]+/g;
  const japaneseRegex = /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FFF\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\uF900-\uFAFF\u2F800-\u2FA1F]/;
  return japaneseRegex.test(str);
}

export const isThai = (str: string) => {
  const thaiRegex = /[a-zA-Z\u0E00-\u0E7F]/;
  return thaiRegex.test(str);
}

// 测试语言
export const checkLanguage = (lang: string, content: string) => {
  console.log(lang, content)
  switch (lang) {
    case 'cn':
      return isChinese(content);
    case 'en':
      return isEnglish(content);
    case 'ko-KR':
      return isKorean(content);
    case 'ja':
      return isJapanese(content);
    case 'th-TH':
      return isThai(content);
    case undefined:
      return isChinese(content);
  }
}
